import { AuthService } from './../../../services/auth.service';
import { ResetPasswordModel } from './../../../models/Auth/ResetPasswordModel';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators, FormGroup, FormControl, FormGroupDirective, NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ErrorStateMatcher } from '@angular/material/core';
import { faTimesCircle } from '@fortawesome/free-regular-svg-icons';
import {MyErrorStateMatcher} from './../../../common/matcher/MyErrorStateMatcher'



@Component({
  selector: 'reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent implements OnInit {
  faTimesCircle=faTimesCircle;
  resetForm:FormGroup;
  isSubmitted;
  wrongQueryParams: boolean = false;
  resetPasswordModel:ResetPasswordModel;
  success: boolean;
  matcher = new MyErrorStateMatcher();
  passwordPattern='^(?=.*[0-9])(?=.*[!@#$%^&*])[0-9a-zA-Z!@#$%^&*0-9]{8,}$';

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private authService:AuthService,
    private router: Router
  ) {

  }

  ngOnInit() {

    this.resetForm = this.formBuilder.group({
      // password: [
      //   '',
      //   [
      //     Validators.required,
      //     Validators.pattern('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&].{8,}')
      //    ]
      // ],
      password: ['', Validators.required],
      confirmPassword: ['', Validators.required],

    },{ validator: this.checkPasswords });

    let userId = this.route.snapshot.queryParams.userId == null ? this.route.snapshot.params.userId : this.route.snapshot.queryParams.userId;
    let email = this.route.snapshot.queryParams.email == null ? this.route.snapshot.params.email : this.route.snapshot.queryParams.email;
    let code = this.route.snapshot.queryParams.code == null ? this.route.snapshot.params.code : this.route.snapshot.queryParams.code;

    if (userId == null || code == null||email==null) {
      //Something wrong
      this.wrongQueryParams = true;

    }
    else {
      this.resetPasswordModel={
        code:code,
        email:email
      }

    }

  }
  get formControls() { return this.resetForm.controls; }

  checkPasswords(group: FormGroup) { // here we have the 'passwords' group
  let pass = group.controls.password.value;
  let confirmPass = group.controls.confirmPassword.value;

  return pass === confirmPass ? null : { notSame: true }
}

  reset() {

    this.isSubmitted=true;
    if(this.resetForm.invalid){
      return;
    }
    let password=this.resetForm.controls["password"].value;
    this.resetPasswordModel.password=password;
    this.authService.resetPassword(this.resetPasswordModel).subscribe(res =>{

      if(res!=null&&res["isSucceed"]){
        this.success=true;
      }
      else{
        this.success=false;
      }
    },
    err=>{
      this.success=false;
    })

  }

  showLogin(){
    this.router.navigate(['/home']);
  }

}
